import { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
 BottomNavbar,
 Loader,
 OfflineDialog,
 TopNavbar,
 IncognitoDialog,
} from "components";
import {
 useAuthentication,
 DialogProvider,
 SnackProvider,
 CartProvider,
} from "hooks";
import { authenticationService } from "services";
import { NotificationProvider } from "contexts";

export function Layout() {
 const { user, loading } = useAuthentication();
 const navigate = useNavigate();
 const location = useLocation();

 const [sessionReady, setSessionReady] = useState(false);
 const [sessionSyncing, setSessionSyncing] = useState(false);

 const urlParams = new URLSearchParams(location.search);
 const returnUrl = urlParams.get("returnUrl");
 const hasReturnUrl = !!(user && returnUrl);

 useEffect(() => {
  if (hasReturnUrl && !sessionReady && !sessionSyncing) {
   setSessionSyncing(true);
   const waitForSession = async () => {
    await authenticationService.syncServerSession(user);
    setSessionReady(true);
    setSessionSyncing(false);
   };
   waitForSession();
  }
 }, [user, hasReturnUrl, sessionReady, sessionSyncing]);

 useEffect(() => {
  if (returnUrl && sessionReady) {
   if (returnUrl.startsWith("http")) {
    window.location.href = returnUrl;
   } else {
    navigate(returnUrl, { replace: true });
   }
  }
 }, [returnUrl, sessionReady, navigate]);

 if (loading || sessionSyncing) {
  return (
   <Loader
    loadingMessage={sessionSyncing ? "Syncing session..." : "Loading..."}
   />
  );
 }

 return (
  <NotificationProvider>
   <CartProvider>
    <DialogProvider>
     <SnackProvider>
      <TopNavbar />
      <OfflineDialog />
      <IncognitoDialog />
      <Outlet />
      <BottomNavbar />
     </SnackProvider>
    </DialogProvider>
   </CartProvider>
  </NotificationProvider>
 );
}
